export enum TrainingReminderTypeModel {
  ConfirmationEmail = 0,
  OneWeekBefore = 1,
  OneDayBefore = 2,
  ThirtyMinutesBefore = 3,
  FifteenMinutesBefore = 4
}